import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=64ddc4cb&scoped=true"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=64ddc4cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ddc4cb",
  null
  
)

export default component.exports